import { useRef } from 'react';
var constantSentinel = Symbol('constant-sentinel');
// https://react.dev/reference/react/useRef#avoiding-recreating-the-ref-contents
/**
 * Call a function once and return its value.
 * Value is identical on each render and never changes, unless the component is unmounted.
 *
 * useMemo can be evacuated from cache in theory.
 * useState(initialState) might be equivalent? But potentially misleading, since it should never change.
 */
export function useConstant(fn) {
    var ref = useRef(constantSentinel);
    if (ref.current === constantSentinel) {
        ref.current = fn();
    }
    return ref.current;
}
